



























import { Component, Emit, Watch } from "vue-property-decorator";
import Vue from "vue";
import FactorScoringDefinitionCreator from "@/components/scoring-definition/FactorScoringDefinitionCreator.vue";
import { getModule } from "vuex-module-decorators";
import Dialogs from "../../store/modules/Dialogs";
import ScoringKeys from "../../store/modules/ScoringKeys";
import Modelling from "@/store/modules/Modelling";
import Decisions from "@/store/modules/Decisions";
import { Factor } from "@/api/model/FactorResource";

const modellingModule = getModule(Modelling)
const decisionsModule = getModule(Decisions)
const scoringKeysModule = getModule(ScoringKeys)
const dialogsModule = getModule(Dialogs)
@Component({
    components: {FactorScoringDefinitionCreator}
})
export default class ModelFactorScoringDefinitionCreatorVuexDialog extends Vue {

    private show = false;

    @Watch('factorId')
    private onIdChanges() {
        if (this.factorId) {
            this.show = true;
        }
    }

    get factorId() {
        return dialogsModule.decisionModelResourceScoringDefinitionEdit
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get scoringDefinition() {
        if (this.resource) {
            return (this.resource as Factor).scoringDefinition
        }
    }

    get scoringKeyDefinitions() {
        return scoringKeysModule.workingModelScoringKeyDefinitions;
    }

    get defaultScoringKeyDefinition() {
        if (this.scoringKeyDefinitions && this.factorId) {
            return this.scoringKeyDefinitions[this.factorId]
        }
    }


    get defaultScoringKeys() {
        if (this.defaultScoringKeyDefinition) {
            return this.defaultScoringKeyDefinition.scoringKeys
        }
    }

    get resource() {
        if (!this.factorId) return;
        return modellingModule.workingModelFactorResources[this.factorId]
    }

    get factorResources() {
        return modellingModule.workingModelFactorResources
    }

    get inheritedFromName() {
        if (!this.defaultScoringKeyDefinition || !this.defaultScoringKeyDefinition.inheritedFrom || !this.factorId) {
            return;
        }
        
        let inheritedFrom = this.defaultScoringKeyDefinition.inheritedFrom;
        let inheritedFromResourceId = this.defaultScoringKeyDefinition.inheritedFromResourceId;

        if(inheritedFromResourceId && inheritedFromResourceId != "M") {
            return `GROUP (${this.factorResources[inheritedFromResourceId].name})`
        }
        if (inheritedFrom === 'DECISION' && this.selectedDecision) {
            return `Model (${this.selectedDecision.name})`
        } else if (inheritedFromResourceId) {
            return `Section (${modellingModule.workingModelFactorResources[inheritedFromResourceId].name})`;
        }
    }

    //We dont actually submit anything here since the model builder syncs the data periodically
    @Emit('submit')
    private submit(scoringDefinition: any) {
        this.show = false;
        let factorId = this.factorId;
        dialogsModule.editDecisionModelResourceScoringDefinition(null)
        return {
            factorId: factorId,
            scoringDefinition: scoringDefinition
        };
    }

    //We dont actually submit anything here since the model builder syncs the data periodically
    @Emit('delete')
    private deleteClick() {
        this.show = false;
        let factorId = this.factorId;
        dialogsModule.editDecisionModelResourceScoringDefinition(null)
        return {
            factorId: factorId,
            scoringDefinition: null
        };
    }

    @Emit('cancel')
    private cancel() {
        this.show = false;
        dialogsModule.editDecisionModelResourceScoringDefinition(null)
    }

}
